import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

export const DELETE_OTHER_ASSET_ENDPOINT = '/Consumer/OtherAssetsUpdate/DeleteOtherAsset';

interface DeleteOtherAssetParams {
  clientId: string;
  assetId: string;
}

const deleteOtherAsset = ({ clientId, assetId }: DeleteOtherAssetParams) => {
  return authFetch(DELETE_OTHER_ASSET_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions({ clientId, id: assetId }),
  });
};

interface Params {
  clientId: string;
}

export const useDeleteAssetMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(deleteOtherAsset, {
    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.otherAssets(clientId));
    },
  });
};
